import { setProblemAsCompleted, setLessonAsCompleted  } from "../../../../../services/userService";

// THIS IS THE ANSWER FOR TESTING THE TEST CASES
// int age;
// double salary;
// String name;

export function testVariableDeclaration(studentCode, checkboxes, user) {
    const agePattern = /\bint\s+age\s*;/;
    const salaryPattern = /\bdouble\s+salary\s*;/;
    const namePattern = /\bString\s+name\s*;/;
    const lessonID = "JA101"

    if (checkboxes.checkbox1 === false) {
        const testResult = agePattern.test(studentCode)
        if(testResult){
            setProblemAsCompleted("JA101P1", user.uid);
            checkboxes.checkbox1 = testResult;
            // console.log("Problem 1 passed");
        }else{
            console.log("Test Failed for problem1: 'age' variable of type int is not declared correctly.");
        }


    }

    if (checkboxes.checkbox2 === false) {
        const testResult = salaryPattern.test(studentCode)
        if(testResult){
            setProblemAsCompleted("JA101P2", user.uid);
            checkboxes.checkbox2 = testResult;
            // console.log("Problem 2 passed");
        }else{
            console.log("Test Failed for problem 2: 'age' variable of type int is not declared correctly.");
        }
    }

    if (checkboxes.checkbox3 === false) {
        const testResult = namePattern.test(studentCode)
        if(testResult){
            setProblemAsCompleted("JA101P3", user.uid);
            checkboxes.checkbox3 = testResult;
        }else{
            console.log("Test Failed for problem 3: 'age' variable of type int is not declared correctly.");
        }
    }

    if(checkboxes.checkbox1 === true && checkboxes.checkbox2 === true && checkboxes.checkbox3 === true){
        setLessonAsCompleted(lessonID, user.uid);
    }

    return checkboxes;
}